(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["itc-industry-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('itc-markets-disclosure')) {
    class ItcMarketsDisclosure extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-itc-markets-toggle]');
        this.panel = this.querySelector('[data-itc-markets-panel]');
        if (!this.button || !this.panel || this.ready) return;
        this.ready = true;
        this.panel.inert = !this.isOpen;

        this.button.addEventListener('click', () => this.setOpen(!this.isOpen));
        this.panel.addEventListener('transitionend', (event) => {
          if (event.target === this.panel && event.propertyName === 'grid-template-rows') this.settle();
        });

        /* Theme editor: open the panel when one of its blocks is selected */
        this.onBlockSelect = (event) => {
          if (this.contains(event.target)) this.setOpen(true);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        clearTimeout(this.settleTimer);
      }

      get isOpen() {
        return this.button.getAttribute('aria-expanded') === 'true';
      }

      setOpen(open) {
        this.button.setAttribute('aria-expanded', String(open));
        this.panel.classList.toggle('is-open', open);
        this.panel.inert = !open;
        clearTimeout(this.settleTimer);
        if (open) {
          /* Fallback for reduced motion or browsers without the transition */
          this.settleTimer = setTimeout(() => this.settle(), 400);
        } else {
          this.panel.classList.remove('is-settled');
        }
      }

      settle() {
        if (this.isOpen) this.panel.classList.add('is-settled');
      }
    }

    customElements.define('itc-markets-disclosure', ItcMarketsDisclosure);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
